/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState } from 'react';
import { DataAPIClientError, UpdateInboxParameters } from './DataAPIClient';
import { useDataAPIClient } from './DataAPIClientProvider';

interface State {
  data?: string;
  error?: DataAPIClientError;
  isProcessing: boolean;
}

interface Result extends State {
  invoke: (inboxID: string, params: UpdateInboxParameters) => void;
}

export default function useDataAPIUpdateInbox(): Result {
  const client = useDataAPIClient();

  const [state, setState] = useState<State>({ isProcessing: false });

  async function invoke(
    inboxID: string,
    params: UpdateInboxParameters
  ): Promise<void> {
    setState({ isProcessing: true });

    try {
      const data = await client.updateInbox(inboxID, params);

      setState({ data, isProcessing: false });
    } catch (error: any) {
      setState({ error, isProcessing: false });
    }
  }

  return { ...state, invoke };
}
